import { LOCATION_CHANGE, push } from "connected-react-router";
import { LOGIN_PATH, NO_ACCESS_PATH } from "@routes/constants";
import { all, takeEvery, takeLatest, select, put, call } from "redux-saga/effects";
import { getTranslateFunction } from "redux-i18n";
import { systemMessages } from "@translations";
import { SuccessMessage } from "@modules/app/constants/actions";
import { isAuthenticated } from "@modules/account/selectors";
import { toast } from "react-toastify";
import { transformError } from "@transformers/response";
import loginActionCreators from "@modules/account/actionCreator";
import appActionCreators from "@modules/app/actionCreator";
import { delay } from "@sagas/utils";
import KeycloakAdapter from "../../../keycloak";
import LocalStorageService from "../../../services/LocalStorageService";
import { isStaticPage } from "@selectors/index";

export function* onError({ payload }) {
  if (!payload) {
    return;
  }

  const isLoggedIn = yield select(isAuthenticated);
  const response = payload.response || payload; // for some reason some *error functions are not handled like the others

  if (response.status === 503) {
    yield all([
      put(appActionCreators.serviceUnavailable(transformError(response))),
      put(loginActionCreators.logoutSuccess()),
      put(push(LOGIN_PATH)),
    ]);
  } else if (response.status === 401) {
    if (isStaticPage()) {
      return;
    }
    yield put(
      toast.warning("Your session has timed out and you are being returned to the login screen."),
    );
    LocalStorageService.clearToken();
    yield call(delay, 5000); // 5sec delay
    yield call(KeycloakAdapter.doLogin());
  } else if (response.status === 403) {
    LocalStorageService.clearToken();
    yield put(push(NO_ACCESS_PATH));
  } else if (isLoggedIn) {
    yield toast.error(transformError(response));
  }
}

export function* onSuccess({ payload }) {
  // TODO: Need to update this when languages are implemented
  const translate = getTranslateFunction(systemMessages, "en", "en");
  yield toast.success(translate(payload) || payload);
}

export function* onLocationChange() {
  yield window.scrollTo(0, 0);
}

export function* appSaga() {
  yield all([
    takeEvery(SuccessMessage, onSuccess),
    takeEvery(action => /^(.*)_ERROR$/.test(action.type), onError),
    takeLatest(LOCATION_CHANGE, onLocationChange),
  ]);
}

export default appSaga;
